import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Box, Tab } from '@mui/material';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import InstallArchive from './InstallArchive';
// import InstallTicket from './InstallTickets/InstallTicket';
// import RepairTicket from './RepairTickets/RepairTicket';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';
import RepairArchive from './RepairArchive';

const Archive = (props) => {
  const location = useLocation();
  const [value, setValue] = useState(location.state || 'repair');
  const [useType, setUseType] = useState(localStorage.getItem('type'));

  const handleChange = (state, newValue) => {
    setValue(newValue);
  };

  return useType === 'technician' ? (
    <UnauthorisedAccess />
  ) : (
    <Box
      xs={{
        maxHeight: '100%',
        minHeight: '70%',
        width: '100%',
        background: 'none',
        border: 'none',
        boxShadow: 'none',
      }}
    >
      <TabContext value={value} sx={{ padding: 'none' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', padding: 'none' }}>
          <TabList
            value={value}
            onChange={handleChange}
            textColor='secondary'
            indicatorColor='secondary'
            aria-label='ticket tabs'
          >
            <Tab
              value='install'
              label='Installation Archive'
              sx={{
                color:
                  value === 'install'
                    ? '#fff !important'
                    : '#354775 !important',
                backgroundColor:
                  value === 'install'
                    ? '#354775   !important'
                    : 'none !important',
                fontWeight:
                  value === 'install' ? '700 !important' : '500 !important',
                border:
                  value === 'install'
                    ? '3px solid #354775 !important'
                    : '2px solid #354775 !important',
                borderRadius: '5px 5px 0 0 ',
              }}
            />

            <Tab
              value='repair'
              label='Repair Archive'
              sx={{
                color:
                  value === 'repair' ? '#fff !important' : '#354775 !important',
                backgroundColor:
                  value === 'repair'
                    ? '#354775   !important'
                    : 'none !important',
                fontWeight:
                  value === 'repair' ? '700 !important' : '500 !important',
                border:
                  value === 'repair'
                    ? '3px solid #354775 !important'
                    : '2px solid #354775 !important',
                borderRadius: '5px 5px 0 0 ',
              }}
            />
          </TabList>
        </Box>

        <TabPanel value='install' style={{ padding: 0 }}>
          {' '}
          <InstallArchive />
        </TabPanel>
        <TabPanel value='repair' style={{ padding: 0 }}>
          {' '}
          <RepairArchive />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default Archive;
